import article1 from "./articles/dubai-property-market-2026";
import article2 from "./articles/golden-visa-dubai-guide";
import article3 from "./articles/best-areas-to-invest-dubai-2026";

/** All articles ordered newest-first */
const ALL_ARTICLES = [article3, article2, article1];

export const getAllArticles = () => ALL_ARTICLES;

export const getFeaturedArticles = (max = 3) =>
  ALL_ARTICLES.filter((a) => a.featured).slice(0, max);

export const getArticleBySlug = (slug) =>
  ALL_ARTICLES.find((a) => a.slug === slug) || null;

export const getArticlesByCategory = (category) =>
  ALL_ARTICLES.filter((a) => a.category === category);

export const getArticlesByTag = (tag) =>
  ALL_ARTICLES.filter((a) => a.tags.includes(tag));

export const getAllCategories = () =>
  [...new Set(ALL_ARTICLES.map((a) => a.category))];

export const getAllTags = () =>
  [...new Set(ALL_ARTICLES.flatMap((a) => a.tags))];

export const getRelatedArticles = (article, max = 3) =>
  (article.relatedArticles || [])
    .map(getArticleBySlug)
    .filter(Boolean)
    .slice(0, max);

// Search logic lives in useBlogSearch hook — no duplicate here
